export const CODES = ['A', 'B', 'C', 'D', 'E'] as const;
